import {BasePage, page} from "./BasePage";
import "./About.css"
import "../css/common.css"

@page("About")
export class About extends BasePage {

	protected get data() {
		return {
			intro: `As one of the most popular variants of poker, Texas Hold'em is a contest of wisdom and courage. Through a combination of soft and hard skills, such as judgment, observation and logical thinking. It is a wise man's game.
As stated by Peter Lynch, “Poker, of all games, is the most like stock investing.”
Developed by an ambitious team of poker lovers, PokerDAO is a revolutionary blockchain-based platform aiming to provide a safe, honest environment for Texas Hold’em enthusiasts as well as building up a DAO, which would also offer web3 benefits.`
		};
	}

	protected webContent() {
		// 在这里完善内容
		return <div>
			<div className="title">ABOUT</div>
			<div className="line"/>
			<div className="intro">{this.data.intro}</div>
			{/* 暂时不要下面的视频 */}
			{/*<div className="videos">*/}
			{/*	<video id={'v1'} onClick={() => playVideo("v1")} src={require('../../assets/card1.mp4')}/>*/}
			{/*	<video id={'v2'} onClick={() => playVideo("v2")} src={require('../../assets/card2.mp4')}/>*/}
			{/*	<video id={'v3'} onClick={() => playVideo("v3")} src={require('../../assets/card3.mp4')}/>*/}
			{/*	<video id={'v4'} onClick={() => playVideo("v4")} src={require('../../assets/card4.mp4')}/>*/}
			{/*	<video id={'v5'} onClick={() => playVideo("v5")} src={require('../../assets/card5.mp4')}/>*/}
			{/*</div>*/}
		</div>
	}

	protected mobileContent(): JSX.Element {
		return <div>
			<div className="title">ABOUT</div>
			<div className="line"/>
			<div className="intro">{this.data.intro}</div>

		</div>;
	}
}
